module.exports = __webpack_public_path__ + "static/media/star-big-sparkling.33d21623.png";